import { AfterViewInit, Component, inject, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Project, RelatedProject } from '@app/core/model/entities/project/project';
import { ProjectsService } from '@app/features/main/views/projects/projects.service';
import {
  MatSelectEntityAutocompleteServerComponent
} from '@app/shared/components/mat-select-autocomplete/mat-select-entity-autocomplete/mat-select-entity-autocomplete-server/mat-select-entity-autocomplete-server.component';
import { eq } from '@app/shared/extra/filter-model-builder';
import { SelectParams } from '@app/shared/grid/datasource-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'mat-select-project-autocomplete',
  styleUrls: ['../mat-select-entity-autocomplete.component.scss'],
  templateUrl: '/mat-select-entity-autocomplete-server.component.html',
  providers: [
    {provide: MatFormFieldControl, useExisting: MatSelectProjectAutocompleteComponent}
  ],
  standalone: false
})
export class MatSelectProjectAutocompleteComponent extends MatSelectEntityAutocompleteServerComponent<RelatedProject, Project> implements AfterViewInit {
  @Input() public assetIds: string[] = [];
  private projectsService = inject(ProjectsService);

  /**
   * Load projects next page.
   * @param startingIndex Page to load. NB: First page is 0.
   * @return Observable<RelatedProject[]> A list of RelatedProject matching the form filters.
   */
  public loadEntitiesNextPage(startingIndex: number): Observable<RelatedProject[]> {
    const params = {...this.buildSelectParams(), start: startingIndex};
    return this.projectsService.loadProjectsPage(params)
      .pipe(map(relatedProjects => relatedProjects.map(project => project.toRelatedProject())));
  }

  /**
   * Build Select Params with filters on typeModules and according to the current form.
   * @return SelectParams
   */
  protected buildSelectParams(): SelectParams {
    const selectParams = super.buildSelectParams();
    selectParams.filters.push(...this.assetIds.map(assetId => eq('assetIds', assetId)));
    return selectParams;
  }
}
